export default "__VITE_ASSET__BsAjU$P9__"